import { Button, Stack, Text } from '@chakra-ui/react';
import type { Dispatch, SetStateAction, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseModal } from 'components';
import { displayAsCurrency } from 'utils';

interface AutoReloadCreditCardModalProps {
  isOpen: boolean;
  onModalClose: () => void;
  redirectUrl: string;
  setRedirectUrl: Dispatch<SetStateAction<string | undefined>>;
}

export const AutoReloadCreditCardModal: FunctionComponent<AutoReloadCreditCardModalProps> = ({
  isOpen,
  onModalClose,
  redirectUrl,
  setRedirectUrl,
}) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      size={['xs', 'md', '2xl', '3xl']}
      isOpen={isOpen}
      onClose={onModalClose}
      header={<Text fontSize="xl">{t('sim.autoReload.creditCardMissing')}</Text>}
      footer={
        <>
          <Button onClick={() => setRedirectUrl(undefined)}>{t('common.back')}</Button>
          <Button
            onClick={() => {
              const link = document.createElement('a');
              // there is a referrer whitelist validation on ApcoPay
              link.referrerPolicy = 'no-referrer';
              link.rel = 'noreferrer';
              link.href = redirectUrl;
              link.click();
            }}
          >
            {t('common.continue')}
          </Button>
        </>
      }
    >
      <Stack spacing="4">
        <Text>
          {t('sim.autoReload.creditCardMissingDescription', {
            authorizationAmount: displayAsCurrency(1),
          })}
        </Text>
        <Text>{t('sim.autoReload.actionAfterCreditCardSetup')}</Text>
      </Stack>
    </BaseModal>
  );
};
